import { jsx as _jsx } from "react/jsx-runtime";
const Schema = ({
  object = {}
}) => {
  return /*#__PURE__*/_jsx("script", {
    type: "application/ld+json",
    children: JSON.stringify(Object.assign({
      '@context': 'http://schema.org'
    }, object), null, 2)
  });
};
export default Schema;